import React from 'react';

import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';
import { useTranslation } from '../../utils/utils';

import { textCaption } from '../../styles/typography';
import { translate } from './translate';

export interface AuthorDateType extends DefaultBsComponent {
  locale?: 'fr' | 'en' | 'es';
  date: Date;
}

const formatDate = (date: Date, locale: string): string => {
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
  }).format(date);
};

export const AuthorDate = ({
  date,
  locale = 'en',
  className,
  as: Component = 'div',
  ...props
}: AuthorDateType) => {
  return (
    <Component
      {...props}
      className={classNames(
        'AuthorDate',
        className,
        textCaption,
        'text-neutral-101 whitespace-nowrap'
      )}
    >{`${useTranslation(translate.udpate, locale)} ${formatDate(date, locale)}`}</Component>
  );
};